define('views/parts/menu/menu-dropdown-item',[
    // Libs
    'jquery',
    'underscore',
    'backbone',
    'mustache',
    'utils',
    'src/routes',
    // templates
    'text!templates/parts/menu/menu-dropdown-item.html',
], function(
    // Libs
    $, _, Backbone, Mustache, U, Routes,
    // templates
    TMenuDropdownItem
) {

    var VMenuDropdown = Backbone.View.extend({
        tagName: "li",
        template: TMenuDropdownItem,
        events: {
            "click": "onClick",
        },

        attributes: function() {
            var attr = {};
            if (this.model.get('role')) attr.role = this.model.get('role');
            // add classes
            if (this.model.get('separator')) {
                attr.class = "divider";
            } else if (this.isTree()) {
                attr.class = "tree";
            } else {
                attr.class = "menu-dropdown-item";
            }

            // remove class attribute if still empty
            // if (_.isEmpty(attr.class)) delete attr.class;

            return attr;
        },

        //
        // regions: {
        // },

        initialize: function(opt) {
            this.options = opt || {};
            // this.options.empty = opt.empty || opt.tree;

            this.model.set('empty', Boolean(this.model.get('empty') || this.model.get('tree')));

        },
        render: function() {
            var html;
            if (this.isTree()) {
                html = this.model.get('view').render().el;
            } else {
                html = Mustache.render(this.template, Mustache.getContext(this.model.toJSON()));
            }
            this.$el.empty().append(html);

            return this;
        },

        isTree: function() {
            return Boolean(this.model.get('tree'));
        },


        ////////////
        // events //
        ////////////
        onClick: function(e) {
            if (this.isTree()) {
                return;
            }
            this.model.trigger("click", this.model);

            // default context to 'this'.
            var context = this.options.context || this,
                callback = this.model.get('callback');

            _.callback(context, callback, [e, this.model]);
        }


    });

    return VMenuDropdown;

});

